<template>
   <div>
       
       <transition  name="fade" mode="out-in">
       <router-view></router-view>
       </transition>

   </div>
</template>

<script>
  //import 
  export default{
    data(){
      return {
      }
    }
  }
</script>

<style scoped>
.fade-enter {
        opacity: 0;
    }
    .fade-enter-active {
        transition: opacity 1s;
    }
    .fade-leave {
        opacity: 1;
    }
    .fade-leave-active {
        transition: opacity 1s;
        opacity: 0;
    }
    .slide-enter {
        opacity: 0;
        /*transform: translateY(20px);*/
    }
    .slide-enter-active {
        animation: slide-in 1s ease-out forwards;
        transition: opacity .2s;
    }
    .slide-leave {
    }
    .slide-leave-active {
        animation: slide-out .5s ease-out forwards;
        transition: opacity 1s;
        opacity: 0;
        position: absolute;
    }
    .slide-move {
        transition: transform 1s;
    }
    @keyframes slide-in {
        from {
            transform: translateY(20px);
        }
        to {
            transform: translateY(0);
        }
    }
    @keyframes slide-out {
        from {
            transform: translateY(0);
        }
        to {
            transform: translateY(20px);
        }
    }
</style>
